import { render, staticRenderFns } from "./SquadTable.vue?vue&type=template&id=5a4cbf44&"
import script from "./SquadTable.vue?vue&type=script&lang=js&"
export * from "./SquadTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports